export default __webpack_public_path__ + "static/media/flag19.c1dbbc41.svg";